import React from 'react'

import {
	ProSidebar,
	Menu,
	MenuItem,
	SubMenu,
	SidebarHeader,
	SidebarFooter,
	SidebarContent,
} from 'react-pro-sidebar'
import {
	FaTachometerAlt,
	FaGem,
	FaList,
	FaGithub,
	FaRegLaughWink,
	FaHeart,
	AiOutlineContacts,
} from 'react-icons/fa'
import { Link, NavLink } from 'react-router-dom'
//import sidebarBg from './assets/bg1.jpg';

const Aside = ({ image, collapsed, rtl, toggled, handleToggleSidebar }) => {
	return (
		<ProSidebar
			// image={image ? sidebarBg : false}
			rtl={rtl}
			collapsed={collapsed}
			toggled={toggled}
			breakPoint='md'
			onToggle={handleToggleSidebar}
		>
			<SidebarHeader>
				<div
					style={{
						padding: '24px',
						textTransform: 'uppercase',
						fontWeight: 'bold',
						fontSize: 14,
						letterSpacing: '1px',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						whiteSpace: 'nowrap',
					}}
				>
					Wyngs Admin Dashboard
				</div>
			</SidebarHeader>

			<SidebarContent>
				<Menu iconShape='circle'>
					<MenuItem icon={<FaGem />}>
						<NavLink
							to='/admin/dashboard'
							activeStyle={{
								color: 'white',
							}}
						>
							Dashboard Banner
						</NavLink>
					</MenuItem>

					<MenuItem icon={<FaGem />}>
						<NavLink
							to='/admin/dashboard/ReviewerList'
							activeStyle={{
								color: 'white',
							}}
						>
							Reviewer List
						</NavLink>
					</MenuItem>
					<MenuItem icon={<FaGem />}>
						<NavLink
							to='/admin/dashboard/feedbackList'
							activeStyle={{
								color: 'white',
							}}
						>
							Feedback List
						</NavLink>
					</MenuItem>

					<MenuItem icon={<FaGem />}>
						<NavLink
							to='/admin/dashboard/getInTouchList'
							activeStyle={{
								color: 'white',
							}}
						>
							Get In Touch List
						</NavLink>
					</MenuItem>

					<MenuItem icon={<FaGem />}>
						<NavLink
							to='/admin/dashboard/Jobpostlist'
							activeStyle={{
								color: 'white',
							}}
						>
							Job Post List
						</NavLink>
					</MenuItem>

					<MenuItem icon={<FaGem />}>
						<NavLink
							to='/admin/dashboard/JobApplicationList'
							activeStyle={{
								color: 'white',
							}}
						>
							Job Application List
						</NavLink>
					</MenuItem>
				</Menu>
			</SidebarContent>

			<SidebarFooter style={{ textAlign: 'center' }}>
				<div
					className='sidebar-btn-wrapper'
					style={{
						padding: '20px 24px',
					}}
				></div>
			</SidebarFooter>
		</ProSidebar>
	)
}

export default Aside
